// extracted by mini-css-extract-plugin
export default {"kpisDiv":"KpisValues_kpisDiv__q0LEc","kpisDivLeft":"KpisValues_kpisDivLeft__CNU95","val":"KpisValues_val__FaoLh","kpisDivRight":"KpisValues_kpisDivRight__9KQTm"};